import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Laboratory from './pages/Laboratory';
import Home from './pages/Home';
import ViewPDF from './pages/ViewPDF';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import ManageFiles from './pages/ManageFiles';
import ThankYou from './pages/ThankYou';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter basename="/cv">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/view" element={<ViewPDF />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/manage-files" element={<ManageFiles />} />
        <Route path="/thank-you" element={<ThankYou />} />
        {/* Route 404 - doit être en dernier */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
